import { defineMessages } from 'react-intl';

export const messages: {
	remixBlockLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remixBlockTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remixDisabledTooltipArchived: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remixDisabledTooltipVersionHistory: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remixInProgressTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remixToolbarLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	remixToolbarTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	remixToolbarTooltip: {
		id: 'highlight-actions.remix.inline-toolbar-tooltip',
		defaultMessage: 'Remix',
		description:
			'Tooltip for the Remix button in the editor inline toolbar that opens a modal to remix or regenerate the block content',
	},
	remixToolbarLabel: {
		id: 'highlight-actions.remix.inline-toolbar-label',
		defaultMessage: 'Remix',
		description:
			'Label for the Remix button in the editor inline toolbar that opens a modal to remix or regenerate the block content',
	},
	remixBlockTooltip: {
		id: 'block-hover.remix.remix-tooltip',
		defaultMessage: 'Remix',
		description:
			'Tooltip for the Remix button in the editor on block hover that opens a modal to remix or regenerate the block content',
	},
	remixBlockLabel: {
		id: 'block-hover.remix.remix-label',
		defaultMessage: 'Remix',
		description:
			'Label for the Remix button in the editor on block hover that opens a modal to remix or regenerate the block content',
	},
	remixDisabledTooltipArchived: {
		id: 'highlight-actions.remix.disabled-tooltip-archived',
		defaultMessage: "Content on archived pages can't be remixed",
		description: 'Tooltip shown on the disabled Remix button when the page is archived',
	},
	remixDisabledTooltipVersionHistory: {
		id: 'highlight-actions.remix.disabled-tooltip-version-history',
		defaultMessage: 'Remix is unavailable in version history',
		description:
			'Tooltip shown on the disabled Remix button when viewing a previous version of the page',
	},
	remixInProgressTooltip: {
		id: 'highlight-actions.remix.in-progress-tooltip',
		defaultMessage: 'Remix in progress...',
		description:
			'Tooltip shown on the disabled Remix button when a remix session is already in progress',
	},
});
